import { LoggingService } from "@/logging/LoggingService";
import { Assert } from "@/common/Assert";
import { LocalDataLoader } from "@/localstorage/LocalDataLoader";
import { CourseBase } from "@/course/CourseBase";
import { SequenceDataMap } from "@/course/SequenceDataMap";
import { Event } from "@/common/Event";
import { CourseEvents } from "@/course/CourseEvents";
const logId = "LocalStorageCourse";
export const createLocalStorageCourse = function (options) {
    LoggingService.log("check local storage environment...", logId);
    Assert.checkArgument(options);
    Assert.checkArgument(options.userId && (options.userId.length > 0));
    Assert.checkArgumentType(options.userId, "string");
    return createCourse(options.userId, options.masteryScore);
};
export function createCourse(userId, masteryScore = 80) {
    LoggingService.log("creating course for localstorage or cookie environment...", logId);
    // @ts-ignore
    const localDataLoader = new LocalDataLoader(userId);
    // @ts-ignore
    const courseBase = new CourseBase(masteryScore || null);
    // @ts-ignore
    const sequenceDataMap = new SequenceDataMap();
    initEventListener();
    function initEventListener() {
        Event.on(document, CourseEvents.COURSE_REFRESH, refreshStatus);
        Event.on(document, CourseEvents.SEQUENCE_TERMINATED, () => {
            courseBase.setSequenceClosed();
            refreshStatus();
        });
    }
    function refreshStatus() {
        localDataLoader.refreshDataBuffer();
    }
    // revealing public api
    return {
        // config api
        getClassName: () => "CookieCourse",
        getProfileController: () => localDataLoader,
        setUsername: localDataLoader.setUsername,
        getUsername: localDataLoader.getUsername,
        /**
         * Gets the storage system for the course.
         *
         * @returns {String} "local_maschine"
         */
        getStorageSystem: () => "local_maschine",
        /**
         * Gets the storage method for the course.
         *
         * @returns {String} "cookies"
         */
        getStorageMethod: localDataLoader.getStorageMethod,
        getCourseMasteryScore: courseBase.getCourseMasteryScore,
        /**
         * It is allowed to start multiple cookie SCOs at the same time.
         *
         * @returns {boolean} true
         */
        isMultiScoLaunchAllowed: () => true,
        useScoLaunchParams: () => false,
        initScoreIDs: sequenceDataMap.initScoreIDs,
        prepareSequenceLaunch: courseBase.setSequenceOpened,
        isSequenceConnected: () => false,
        initSequenceData: sequenceDataMap.initSequenceData,
        getSequenceData: sequenceDataMap.getSequenceData,
        setSequenceData: sequenceDataMap.setSequenceData,
        getSequenceDataMap: sequenceDataMap.getSequenceDataMap,
        clearSequenceDataMap: sequenceDataMap.clearSequenceDataMap,
        /**
         * Does nothing for a cookie course
         */
        terminate: () => { },
        exit: () => {
            // should be implemented when course uses a close button
        },
        /**
         * @deprecated
         *
         * @return {Boolean} true
         */
        handleBrowserOnTerminate: () => true,
        //core api
        onSequenceTerminate: courseBase.setSequenceClosed,
        getSequenceInfos: sequenceDataMap.getSequenceInfos,
        getResultMap: sequenceDataMap.getResultMap,
        getScoreIDs: sequenceDataMap.getScoreIDs,
        refreshStatus: refreshStatus
    };
}
